/* eslint-disable */
export default {
  schedule: '安排会议',
  prompt: '请授权 RingCentral 访问您的帐户信息。',
  saveAsDefault: '另存为默认值',
  launchMeeting: '启动会议',
} as const;

// @key: @#@"schedule"@#@ @source: @#@"Schedule Meeting"@#@
// @key: @#@"prompt"@#@ @source: @#@"Please authorize RingCentral to access your account information."@#@
// @key: @#@"saveAsDefault"@#@ @source: @#@"Save as default"@#@
// @key: @#@"launchMeeting"@#@ @source: @#@"Launch Meeting"@#@
